import type { DocFieldSchema } from "@/lib/erp/meta";

/** Field types that are not click-to-edit (always modal or always interactive) */
const SKIP_TYPES = new Set(["Table", "Table MultiSelect", "Check"]);

/**
 * Get the next or previous editable field in a list.
 *
 * Skips read-only fields, Table/TableMultiSelect (modal-only), and Check (always-interactive).
 * Returns null if no adjacent editable field exists (Tab should leave the card).
 * Does NOT wrap around — at the boundary, returns null.
 */
export function getAdjacentField(
  fields: DocFieldSchema[],
  currentFieldname: string,
  direction: "next" | "prev"
): string | null {
  const currentIndex = fields.findIndex(
    (f) => f.fieldname === currentFieldname
  );
  if (currentIndex === -1) return null;

  const step = direction === "next" ? 1 : -1;
  let i = currentIndex + step;

  while (i >= 0 && i < fields.length) {
    const field = fields[i];
    if (
      !SKIP_TYPES.has(field.fieldtype) &&
      field.read_only !== 1
    ) {
      return field.fieldname;
    }
    i += step;
  }

  return null;
}
